export enum LocalStorageKey {
	CALENDAR_TOOLBAR = 'calendarToolbar',
	OPEN_USER_SETTINGS = 'openUserSettings',
}
